module.exports = __webpack_public_path__ + "static/media/portfolio-4.33c3b76e.jpg";